import React from 'react';
import useIsGridPaginationEnabled from 'features/queue/newGrid/hooks/useIsGridPaginationEnabled';
import NewNextOrPrevSR from 'features/header/newGrid/next-or-prev-sr';
import OldNextOrPrevSR from 'features/header/next-or-prev-sr/old-next-or-prev';

interface Props {
    srId: number;
}

const NextOrPrevSR: React.FC<Props> = ({ srId }) => {
    const isGridPaginationEnabled = useIsGridPaginationEnabled();

    if (isGridPaginationEnabled === undefined) {
        return null;
    }
    if (isGridPaginationEnabled) {
        return <NewNextOrPrevSR srId={srId} />
    }
    return <OldNextOrPrevSR srId={srId} />
}

export default NextOrPrevSR;